export { AmplitudeCore } from './core-client';
export { Identify } from './identify';
export { Revenue } from './revenue';
export { Destination } from './plugins/destination';
export { Config } from './config';
export { Logger } from './logger';
export { AMPLITUDE_PREFIX } from './constants';
export { returnWrapper } from './utils/return-wrapper';
export { debugWrapper, getClientLogConfig, getClientStates } from './utils/debug';
export { UUID } from './utils/uuid';
export { MemoryStorage } from './storage/memory';
export { BaseTransport } from './transports/base';
export { createIdentifyEvent } from './utils/event-builder';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amplitude/analytics-core/lib/esm/index.js
// module id = 14
// module chunks = 0